import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Carousel = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-advance slides every 15 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % slides.length);
    }, 17000);

    return () => clearInterval(timer);
  }, [slides.length]);

  if (!slides || slides.length === 0) {
    return (
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg?20200913095930"
        alt="carousel-image"
        className="w-screen h-screen object-cover"
      />
    );
  }

  const prevImage = () => {
    setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);
  }

  const nextImage = () => {
    setCurrentIndex(prev => (prev + 1) % slides.length);
  }

  return (
    <div className="w-screen h-full relative overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-700 ${
            currentIndex === index ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {/* Background Image */}
          <img
            src={slide.imageUrl}
            className="md:w-[120%] md:h-[120%] w-full h-full object-cover"
            alt={`slide-${index}`}
          />
          

          {/* Content Overlay */}
          <div className="absolute inset-0 md:flex flex-colitems-center mt-10 justify-between md:px-16 px-4">
            {/* Left side - Button */}
            <div className="flex flex-col self-end items-center mb-16"> 

            <div className="z-10">
              <Link 


                to={slide.buttonLink}
                className="flex items-center bg-transparent border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:bg-opacity-10 transition-all duration-300"
              >
                <span className="text-2xl tracking-widest font-light">
                  {slide.buttonText}
                </span>
              </Link>
            </div>
 
            </div>

            {/* Right side - Text */}
            <div className={`max-w-md text-white ${
              slide.textPosition === 'top' ? 'self-start mt-32' : 'self-end mb-16'
            }`}>
              <p className="text-4xl text-center">{slide.description}</p>
            </div>
          </div>
        </div>
      ))}
      
      {/* Navigation Buttons */}
      <button onClick={prevImage} className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white z-10 text-3xl">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button onClick={nextImage} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white z-10 text-3xl">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export default Carousel;
